// extracted by mini-css-extract-plugin
export default {"entityIcon":"LockedEntityType_entityIcon__r5RL6"};